import clearIsDirty from '../../actions/clearIsDirty';
import saveSignatureOption from '../../actions/signature/saveSignatureOption';
import SignatureViewState from '../../store/schema/SignatureViewState';
import { getOptionsStore } from '../../store/Store';
import { hideFullScreenSpinner, showFullScreenSpinner } from 'mini-full-screen-spinner';
import { lazyInitMailSignatureCloudSettings } from 'mini-mail-signature-cloud-settings';
import { orchestrator } from 'satcheljs';
import {
    EmailSignaturePreference,
    updateEmailSignaturePreference,
} from 'mini-bx-user-custom-properties';
import {
    getEmailSignaturePreferenceFromCache,
    storeEmailSignaturePreferenceInCache,
} from 'mini-mail-signature';

const saveSignatureOptionOrchestrator = orchestrator(saveSignatureOption, async () => {
    const optionsStore = getOptionsStore();
    if (optionsStore && optionsStore.activeViewState) {
        // show the spinner
        showFullScreenSpinner();

        // perform the remote save
        const signatureViewState = optionsStore.activeViewState as SignatureViewState;
        const { useDesktopSignature } = signatureViewState;

        const emailSignaturePreferenceInServer = getEmailSignaturePreferenceFromCache();
        let serviceOptions: EmailSignaturePreference;

        // if the new state is different from the one in the cache, update the cache
        if (useDesktopSignature !== emailSignaturePreferenceInServer?.UseDesktopSignature) {
            serviceOptions = { UseDesktopSignature: useDesktopSignature };
        }

        if (!serviceOptions) {
            // no need to update the server if there's nothing to update
            clearIsDirty();
        } else {
            const response = await updateEmailSignaturePreference(serviceOptions);
            // perform the local save if successful
            if (response?.Id) {
                storeEmailSignaturePreferenceInCache(response.data);
                clearIsDirty(); // clear the flag only on a success so that the save button is disabled only on a success

                // load the cloud settings for email signatures from big OWA to show the signatures while composing email
                if (response.data?.UseDesktopSignature) {
                    lazyInitMailSignatureCloudSettings.importAndExecute();
                }
            }
        }

        // remove the spinner
        hideFullScreenSpinner();
    }
});

export default saveSignatureOptionOrchestrator;
